import React from "react";
import { useContext } from "react";
import Context from "../context";
import {
	Box,
	Button,
	Grid,
	Paper,
	Typography,
	Avatar,
	Tooltip,
} from "@mui/material";
import { Edit as EditIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { styled, useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

// Styled Components for Animations
const FadeInPaper = styled(Paper)(({ theme }) => ({
	padding: theme.spacing(4),
	borderRadius: theme.shape.borderRadius * 2,
	boxShadow: theme.shadows[3],
	transition: "transform 0.3s, box-shadow 0.3s",
	"&:hover": {
		transform: "translateY(-5px)",
		boxShadow: theme.shadows[6],
	},
}));

const ActionButton = styled(Button)(({ theme }) => ({
	textTransform: "none",
	marginTop: theme.spacing(2),
	padding: theme.spacing(1.5, 3),
	borderRadius: theme.shape.borderRadius,
	transition: "background-color 0.3s",
	"&:hover": {
		backgroundColor: theme.palette.primary.dark,
	},
}));

export default function Perfil() {
	const user = useContext(Context); // Access user context
	const navigate = useNavigate();
	const theme = useTheme();
	const { t } = useTranslation();

	return (
		<Box
			sx={{
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				minHeight: "100vh",
				backgroundColor: "#f0f2f5",
				padding: 2,
			}}
		>
			<FadeInPaper elevation={6}>
				<Grid
					container
					spacing={4}
					alignItems="center"
					justifyContent="center"
				>
					{/* User Information */}
					<Grid item xs={12} md={6}>
						<Box
							sx={{
								display: "flex",
								flexDirection: "column",
								alignItems: { xs: "center", md: "flex-start" },
								textAlign: { xs: "center", md: "left" },
								padding: { xs: 2, md: 0 },
							}}
						>
							<Typography
								variant="h4"
								component="h1"
								gutterBottom
								sx={{ fontWeight: "bold", color: theme.palette.primary.main }}
							>
								{user?.name}
							</Typography>
							<Typography
								variant="h6"
								component="h2"
								gutterBottom
								sx={{ color: theme.palette.text.secondary }}
							>
								{user?.email}
							</Typography>
							<Typography
								variant="subtitle1"
								gutterBottom
								sx={{ color: theme.palette.text.secondary, marginBottom: 3 }}
							>
								{user?.roles[0] === "ADMIN" ? t("COMMON.ROLE_ADMIN") : t("COMMON.ROLE_BACKOFFICE")}
							</Typography>
							<Tooltip title={t("PROFILE.CHANGE_PASSWORD")} arrow>
								<ActionButton
									variant="contained"
									color="primary"
									startIcon={<EditIcon />}
									onClick={() => navigate("change-password")}
								>
									{t("PROFILE.CHANGE_PASSWORD")}
								</ActionButton>
							</Tooltip>
						</Box>
					</Grid>

					{/* User Avatar */}
					<Grid item xs={12} md={6}>
						<Box
							sx={{
								display: "flex",
								justifyContent: { xs: "center", md: "flex-end" },
							}}
						>
							<Avatar
								alt={user?.name}
								src={user?.avatar || "/logo192.png"}
								sx={{
									width: { xs: 150, md: 200 },
									height: { xs: 150, md: 200 },
									boxShadow: theme.shadows[4],
									border: `4px solid ${theme.palette.primary.main}`,
									transition: "transform 0.3s",
									"&:hover": {
										transform: "scale(1.05)",
									},
								}}
							/>
						</Box>
					</Grid>
				</Grid>
			</FadeInPaper>
		</Box>
	);
}
